<template>
  <SharedDialog ref="sharedDialog"
                title="Filteränderungen nicht übernommen"
                @close="$emit('change-filters')">
    <template #header>
      <div class="bx-dialog__title">
        <h2>Filteränderungen nicht übernommen</h2>
      </div>
    </template>

    <div class="bx-content__continuous-text bx-typo--content-continuous-text bx-typo--center">
      <p>
        Du hast deine Filter geändert, aber noch nicht angewendet.<br>
        Möchtest du die Änderungen jetzt anwenden oder verwerfen?
      </p>
    </div>

    <form class="bx-form bx-typo--form">
      <div class="bx-form__item bx-form__item--centered">
        <button class="bx-form__button bx-form__button--secondary"
                type="button"
                @click.prevent="$emit('discard-filters')">
          Änderungen verwerfen
        </button>
        <button type="button"
                class="bx-form__button"
                @click="$emit('apply-filters')">
          Filter anwenden
        </button>
      </div>
    </form>
  </SharedDialog>
</template>

<script>
import SharedDialog from '../../../../../components/shared/Dialog.vue'
import { useKeepTabbingFocus } from '../../../../../composables/use-keep-tabbing-focus'

export default {
  components: {
    SharedDialog
  },
  emits: ['apply-filters', 'discard-filters', 'change-filters'],
  setup () {
    return { ...useKeepTabbingFocus() }
  },
  mounted () {
    this.keepTabbingFocusInFilterDialog()
  },
  methods: {
    keepTabbingFocusInFilterDialog () {
      this.$nextTick(() => {
        this.removeTabbingEventListeners()
        this.keepTabbingFocus(this.$refs.sharedDialog.$el, ['button'], 0, () => {
          this.removeTabbingEventListeners()
          this.$emit('change-filters')
        })
      })
    }
  }
}
</script>
